import PrivacyPolicyDates from './Dates/PrivacyPolicyDates';
import styles from './Main.module.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

export default function PrivacyPolicyMain({ fields }) {
  return (
    <div className={styles.main}>
      <div className="container">
        <div className={styles.inner}>
          <PrivacyPolicyDates fields={fields} />
          <RichText field={fields.content}></RichText>
        </div>
      </div>
    </div>
  );
}
